__turbopack_context__.v({
  "AwardItem": "Awards-module-sass-module__I7JrUG__AwardItem",
  "Awards": "Awards-module-sass-module__I7JrUG__Awards",
  "AwardsCont": "Awards-module-sass-module__I7JrUG__AwardsCont",
  "AwardsRow": "Awards-module-sass-module__I7JrUG__AwardsRow",
  "AwardsTitle": "Awards-module-sass-module__I7JrUG__AwardsTitle",
  "Cont": "Awards-module-sass-module__I7JrUG__Cont",
  "SecondaryImage": "Awards-module-sass-module__I7JrUG__SecondaryImage",
});
